'use es6';

import PropTypes from 'prop-types';
import { Fragment, memo, useMemo } from 'react';
import styled from 'styled-components';
import UINumberRating from 'UIComponents/input/UINumberRating';
import * as Devices from 'feedback-schema/constants/devices';
import { oneOfObjectKeys } from 'feedback-utils/propTypes';
import { makeSafeInnerHTML } from 'feedback-utils/sanitize';
import FeedbackNpsBoxRatings from 'feedback-shared-ui/ratings/internal/FeedbackNpsBoxRatings';
import { useWindowSize } from 'forms-utils-lib/hooks/useWindowSize';
import { getIsNpsRatings, getIsTabletOrMobileSize, getMaxButtonsPerRow, getIsDeviceMobileOrTablet } from 'feedback-shared-ui/ratings/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Label = styled.div.withConfig({
  displayName: "FeedbackNumberRating__Label",
  componentId: "t17ulg-0"
})(({
  theme
}) => `
  margin-top: ${theme.space['200']};
`);
const FeedbackNumberRating = /*#__PURE__*/memo(({
  device,
  highRangeLabel,
  lowRangeLabel,
  max,
  min,
  name,
  onChange,
  isWebSurvey = false,
  value,
  'data-selenium-test': dataSeleniumTest,
  required
}) => {
  const buttons = max - min + 1;
  const deviceSize = useWindowSize();
  const isNpsRatings = useMemo(() => getIsNpsRatings(name), [name]);
  const maxButtonsPerRow = useMemo(() => getMaxButtonsPerRow({
    buttons,
    device,
    isNpsRatings
  }), [buttons, device, isNpsRatings]);
  const showNpsDroppdown = useMemo(() => isNpsRatings && !isWebSurvey && (getIsDeviceMobileOrTablet(device) || getIsTabletOrMobileSize(deviceSize)), [device, isNpsRatings, isWebSurvey, deviceSize]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [!showNpsDroppdown && /*#__PURE__*/_jsx(UINumberRating, {
      "data-selenium-test": dataSeleniumTest,
      highRangeLabel: /*#__PURE__*/_jsx(Label, {
        dangerouslySetInnerHTML: makeSafeInnerHTML(highRangeLabel)
      }),
      lowRangeLabel: /*#__PURE__*/_jsx(Label, {
        dangerouslySetInnerHTML: makeSafeInnerHTML(lowRangeLabel)
      }),
      max: max,
      maxPerRow: maxButtonsPerRow,
      min: min,
      name: name,
      maxWidth: "100%",
      onChange: ({
        target: {
          value: targetValue
        }
      }) => {
        if (onChange) onChange(targetValue);
      },
      value: value,
      required: required
    }), showNpsDroppdown && /*#__PURE__*/_jsx(FeedbackNpsBoxRatings, {
      onRatingChange: onChange,
      selectedRating: value,
      lowRangeLabel: lowRangeLabel,
      highRangeLabel: highRangeLabel
    })]
  });
});
FeedbackNumberRating.propTypes = {
  device: oneOfObjectKeys(Devices).isRequired,
  highRangeLabel: PropTypes.string.isRequired,
  lowRangeLabel: PropTypes.string.isRequired,
  maxWidth: PropTypes.number,
  max: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  isWebSurvey: PropTypes.bool,
  'data-selenium-test': PropTypes.string,
  required: PropTypes.bool
};
export default FeedbackNumberRating;